// Regras de movimentacao de cards entre colunas, compartilhadas pelas duas Homes,
// pelo Card e pelo PreviewCard. Os nomes das colunas vem do cadastro e podem ter
// espacos sobrando (ex.: "Dia 2  "), por isso a comparacao e normalizada.

export function normalizeColumnName(name) {
  return String(name ?? '').replace(/\s+/g, ' ').trim().toLowerCase();
}

// Cards que ja foram arquivados ficam bloqueados e so podem ir para estas colunas.
export const BLOCKED_CARD_ALLOWED_COLUMNS = ['Em Contato', 'Sem Retorno', 'Link Patrocinado'];

export const BLOCKED_CARD_MESSAGE =
  "Não é possível mover o card. O card está bloqueado e só pode ser movido para as colunas 'Em Contato', 'Sem Retorno' ou 'Link Patrocinado'.";

export function canMoveBlockedCardTo(targetColumnName) {
  const target = normalizeColumnName(targetColumnName);
  return BLOCKED_CARD_ALLOWED_COLUMNS.some((name) => normalizeColumnName(name) === target);
}

// Etapas iniciais da qualificacao: entre elas o card pode andar sem cidade/estado.
export const LOCATION_OPTIONAL_COLUMNS = ['Primeiro Contato', 'Dia 1', 'Dia 2', 'Dia 3'];

export function isLocationOptionalMove(sourceColumnName, targetColumnName) {
  const optional = LOCATION_OPTIONAL_COLUMNS.map(normalizeColumnName);
  return optional.includes(normalizeColumnName(sourceColumnName))
    && optional.includes(normalizeColumnName(targetColumnName));
}
